import React from "react";

const StepBoxes = ({ text, index }) => {
  return (
    <div className="box is-connected center">
      <h3 style={{margin: 0}}>
        <span style={{ color: "#22e06c", fontWeight: "bold", marginRight: "0.5em" }}>
          {index + 1}.
        </span>
        {text}
      </h3>
    </div>
  );
};

export default StepBoxes;